import { paymentSlipStrings } from '@data/paymentSlip';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: paymentSlipStrings.payment_slip,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: true,
};
